/*
 * SonarQube
 * Copyright (C) 2009-2025 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import styled from '@emotion/styled';
import * as Echoes from '@sonarsource/echoes-react';
import tw from 'twin.macro';

/** @deprecated Wrap your list in the {@link Echoes.Text | Text} component from Echoes instead, it supports formatting for lists. */
export const UnorderedList = styled.ul<{ ticks?: boolean }>`
  list-style: ${({ ticks }) => (ticks ? 'disc' : 'none')};
  ${tw`sw-mt-4`}
  ${tw`sw-pl-0`}

  li:last-child {
    ${tw`sw-mb-0`}
  }
`;

UnorderedList.displayName = 'UnorderedList';
